import { render, staticRenderFns } from "./MenuSettingsModal.vue?vue&type=template&id=386dcab0&scoped=true"
import script from "./MenuSettingsModal.vue?vue&type=script&lang=js"
export * from "./MenuSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./MenuSettingsModal.vue?vue&type=style&index=0&id=386dcab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386dcab0",
  null
  
)

export default component.exports